<template>
  <ValidationObserver v-slot="{ invalid }">
    <el-form
      ref="loginForm"
      :model="loginForm"
      class="login-form"
      auto-complete="on"
      label-position="left"
    >
      <div class="my-9 text-base font-medium">
        ユーザーログイン
      </div>

      <p class="mb-6 text-red-500">{{ errorLogin }}</p>
      <ValidationProvider
        name="メールアドレス"
        :rules="{
          required: true,
        }"
        v-slot="{ errors }"
        class=""
      >
        <el-form-item prop="email">
          <span class="svg-container">
            <img src="@/assets/login/user.png" alt="" />
          </span>
          <el-input
            v-model="loginForm.email"
            name="email"
            type="text"
            :placeholder="'メールアドレス'"
          />
        </el-form-item>
        <span class="text-red-500">{{ errors[0] }}</span>
      </ValidationProvider>

      <ValidationProvider
        name="パスワードの長さは"
        :rules="{
          min: 8,
          max:20
        }"
        v-slot="{ errors }"
        class=""
      >
        <el-form-item prop="password">
          <span class="svg-container">
            <img src="@/assets/login/lock.png" alt="" />
          </span>
          <el-input
            v-model.trim="loginForm.password"
            name="password"
            auto-complete="on"
            placeholder="パスワード"
            :type="pwdType"
            @keyup.enter.native="handleLogin"
          />
          <span class="show-pwd" @click="showPwd">
            <font-awesome-icon icon="eye" />
          </span>
        </el-form-item>
        <span class="text-red-500">{{ errors[0] }}</span>
      </ValidationProvider>

      <div class="option">
        <div class="mt-6">
          <el-checkbox v-model="remember" label="ログイン情報を記憶する" size="large"></el-checkbox>
        </div>
        <div class="forgot mt-6">
<!--          <router-link :to="{ name: 'forgot_password' }">-->
<!--            パスワードを忘れ方はこちら-->
<!--          </router-link>-->
        </div>
      </div>

      <el-button
        class="mt-6"
        :loading="loading"
        style="width: 100%; color: black; background: #FDB92C;"
        @click.native.prevent="handleLogin"
        :disabled="invalid || form_null"
      >
        <span class="font-normal text-base">{{ "ログイン" }}</span>
      </el-button>
    </el-form>
  </ValidationObserver>
</template>

<script>
const logo = require("@/assets/login/logo.png");
import { mapActions, mapState } from "vuex";
export default {
  data: function() {
    return {
      loginForm: {
        email: "",
        password: "",
      },
      pwdType: "password",
      logo: logo,
      loading: false,
      loginFailedText: "ログイン失敗しました。",
      errorLogin: '',
      remember: false
    };
  },
  methods: {
    showPwd() {
      if (this.pwdType === "password") {
        this.pwdType = "";
      } else {
        this.pwdType = "password";
      }
    },
    ...mapActions("auth", ["auth"]),
    async handleLogin() {
      let response = await this.auth({
        sefl: this,
        data: this.loginForm,
      });
      if (!response.success) {
        this.errorLogin = response.data.message;
      } else {
        if (this.remember) {
          this.$cookies.set('remember', true, '2d')
          const key_word = '' + JSON.stringify(this.loginForm) + ''
          this.$cookies.set('key_word', window.btoa(key_word), '2d')
        } else {
          this.$cookies.remove('remember')
          this.$cookies.remove('key_word')
        }
      }
    },
  },
  computed: {
    ...mapState({
      loginFailed: (state) => state.auth.loginFailed,
    }),
    form_null() {
      return !this.loginForm.email || !this.loginForm.password;
    },
  },
  created: function() {

    this.remember = JSON.parse(this.$cookies.get('remember'))
    if (this.remember) {
      try {
        const form = JSON.parse(window.atob(this.$cookies.get('key_word')))
        this.loginForm.email = form.email
        this.loginForm.password = form.password
      } catch (error) {
        var email = this.$router.app._route.query.email;
        if (email) {
          this.loginForm.email = email;
        }
      }
    }
  },
};
</script>

<style scoped>
.forgot {
  color: #fdb92c;
  font-size: 16px;
  font-weight: 400;
}
</style>
